import { default as React } from 'react';
import styles from './MedicationStatusIcon.module.css';
import { CloudDoneIcon, CloudUploadIcon, CloudCircleIcon } from '../Components/Icons';
import { MedicationStatus } from '../Contracts/MedicationModels';
import { green, orange } from '../Styles/Colours';
import { Tooltip } from '@material-ui/core';
export var MedicationStatusIcon = function (props) {
    var statusIcon = function () {
        switch (props.medicationStatus) {
            case MedicationStatus.Finalised:
                return (React.createElement(Tooltip, { title: 'This medication has been finalised' },
                    React.createElement("span", null,
                        React.createElement(CloudDoneIcon, { color: green }))));
            case MedicationStatus.Draft:
                return (React.createElement(Tooltip, { title: 'This medication is in draft' },
                    React.createElement("span", null,
                        React.createElement(CloudUploadIcon, { color: orange }))));
            case MedicationStatus.Stopped:
                return (React.createElement(Tooltip, { title: 'This medication has been stopped' },
                    React.createElement("span", null,
                        React.createElement(CloudCircleIcon, null))));
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    return React.createElement("div", { className: styles.statusIcon }, statusIcon());
};
